import React from 'react';
import PropTypes from 'prop-types';
import ConversionResultsValue from './ConversionResultsValue';
import ConversionResultsValueLabel from './ConversionResultsValueLabel';
import useCopied from '../../../utils/useCopied';

const DetailsItem = ({ value, copyValue }) => {
    const { copyToClipboard } = useCopied();

    return (
        <ConversionResultsValue>
            <ConversionResultsValueLabel
                onClick={() => {
                    copyToClipboard({ valueCopied: copyValue, labelCopied: value });
                }}
            >
                {value}
            </ConversionResultsValueLabel>
        </ConversionResultsValue>
    );
};

DetailsItem.propTypes = {
    value: PropTypes.node.isRequired,
    copyValue: PropTypes.string.isRequired,
};

export default DetailsItem;
